import React from 'react';
import {reduxForm} from 'redux-form';
import {Alert} from 'elemental';
import BaseForm from '../form/base-form';
import FormField from '../form/form-field';
import DateField from '../form/date-field';
import GenderField from '../form/gender-field';
import DistanceSelectField from '../stage/distance-select';
import LocalizedStrings from '../../localization/strings';
import Button from '../button';
import {validateRequiredFields, validateEmail, validateDate} from '../../utils/form';
import moment from 'moment';
import {isEnglish} from '../../localization/language-cookie';

const fields = [
    'id',
    'first_name',
    'last_name',
    'birth_date',
    'phone',
    'friend_phone',
    'city',
    'club',
    'email',
    'gender',
    'stageId',
    'distanceId',
    'createdAt',
    'payed',
    'payment',
    'uuid',
    'agree_on_regulations',
    'medical_confirmation',
    'participate_in_insurance',
    'marketing_email',
    'country',
    'gdpr_confirmation',
    'promo_code',
    'related_participant_identifier'
];

function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, [
        'first_name',
        'last_name',
        'birth_date',
        'phone',
        'email',
        'distanceId',
        'stageId',
        'gender',
        'agree_on_regulations',
        'medical_confirmation',
        'gdpr_confirmation'
    ], errors);
    errors = validateEmail(values, 'email', errors);
    errors = validateDate(values, 'birth_date', errors);

    return errors;
}

class ParticipantForm extends BaseForm {
    constructor(props) {
              super(props);
               this.state = {
                   selectedStage: null,
                   price: null,
                   calculating: false
                };
            }


    showAlert() {
        const {
            showAlert = true
        } = this.props;

        return showAlert;
    }

    selectStage(id) {
        const {stages} = this.props;
        let stageById;
        stages.forEach((stage) => {
            if (stage.id === id) {
                stageById = stage;
            }
        });
        return stageById;
    }

    calculatePrice() {
        let {stageId, distanceId, birth_date, createdAt, promo_code} = this.props.values;

        if (birth_date) {
            birth_date = moment(birth_date).format('YYYY-MM-DD');
        }
        if(createdAt){
            createdAt = moment(createdAt).format('YYYY-MM-DD')
        }

        if (distanceId  && birth_date && stageId) {
            this.setState({calculating: true});
            fetch(`/api/participant/calculate-price?distanceId=${distanceId? distanceId: ''}&stageId=${stageId? stageId: ''}&birth_date=${birth_date? birth_date: ''}&created_at=${createdAt? createdAt: ''}&promo=${promo_code?promo_code: ''}`).then(response => {
                return response.json();
            }).then((response) => {
                this.setState({price: response.price, calculating: false});
            }).catch(e => {
                console.error('failed to get price', e);
            }).then(() => {
                this.setState({calculating: false});
            });
        }
    }

    getInsuranceLabel() {
        return isEnglish()
            ? window.CARE_CONFIG.settings.insurance_text_in_registration_en
            : window.CARE_CONFIG.settings.insurance_text_in_registration;
    }

    componentDidUpdate(prevProps){
        let {stageId, distanceId, birth_date, promo_code} = this.props.values;
        if(prevProps.values.stageId !== stageId || prevProps.values.distanceId !== distanceId || prevProps.values.birth_date !== birth_date || prevProps.values.promo_code !== promo_code){
          this.calculatePrice();
        }
      }


    onStageSelect(selectedStage) {
        const stage = this.selectStage(selectedStage.value);
        this.setState({selectedStage: stage});
   }

    render() {
        const {
            submitting,
            error,
            handleSubmit,
            disableStageSelect = false,
            displayPayed = false,
            fields: {
                first_name,
                last_name,
                birth_date,
                phone,
                friend_phone,
                city,
                club,
                email,
                gender,
                stageId,
                distanceId,
                payed,
                agree_on_regulations,
                medical_confirmation,
                participate_in_insurance,
                marketing_email,
                country,
                gdpr_confirmation,
                promo_code,
                related_participant_identifier
            }
        } = this.props;
        const {id, payment} = this.props.values;
        const {selectedStage, price} = this.state;
        return (
            <div>
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}
                    {related_participant_identifier.value && <div>{LocalizedStrings.seasonPersonIdentifier}: {related_participant_identifier.value}</div>}

                    <div className="distance-price-row">
                        <DistanceSelectField stageField={stageId} distanceField={distanceId} disableStageSelect={disableStageSelect} onStageSelect={this.onStageSelect.bind(this)} ></DistanceSelectField>

                        <div className="price-display">
                            <span className="price-title">{LocalizedStrings.price}:</span>
                            <span className="amount-display">{price !== null ? price : (payment? payment.price: 0)}</span>
                        </div>
                    </div>

                    <div className="form-row">
                        <FormField label={LocalizedStrings.firstName} name="name" field={first_name}>
                            <input ref="name" placeholder={LocalizedStrings.firstName} type="text" {...first_name}/>
                        </FormField>

                        <FormField label={LocalizedStrings.lastName} name="last_name" field={last_name}>
                            <input ref="last_name" placeholder={LocalizedStrings.lastName} type="text" {...last_name}/>
                        </FormField>
                    </div>
                    <div className="form-row">
                        <FormField label={LocalizedStrings.gender} name="gender" field={gender}>
                            <GenderField field={gender}></GenderField>
                        </FormField>
                        <FormField label={LocalizedStrings.birthDate} name="birth_date" field={birth_date}>
                            <DateField {...birth_date} timeFormat={false} noTimeZoneDate={true}
                                       viewMode="years"></DateField>
                        </FormField>
                    </div>
                    <div className="form-row">
                        <FormField label={LocalizedStrings.email} name="email" field={email}>
                            <input ref="email" placeholder={LocalizedStrings.email} type="text" {...email}/>
                        </FormField>
                        <FormField label={LocalizedStrings.phone} name="phone" field={phone}>
                            <input ref="phone" placeholder={LocalizedStrings.phone} type="text" {...phone}/>
                        </FormField>
                        <FormField label={LocalizedStrings.friendPhone} name="friend_phone" field={friend_phone}>
                            <input ref="friend_phone" placeholder={LocalizedStrings.friendPhone} type="text" {...friend_phone}/>
                        </FormField>
                    </div>
                    <div className="form-row">
                        <FormField label={LocalizedStrings.city} name="city" field={city}>
                            <input ref="city" placeholder={LocalizedStrings.city} type="text" {...city}/>
                        </FormField>
                        <FormField label={LocalizedStrings.club} name="club" field={club}>
                            <input ref="club" placeholder={LocalizedStrings.club} type="text" {...club}/>
                        </FormField>

                        <FormField label={LocalizedStrings.country} name="country" field={country}>
                            <input ref="country" placeholder={LocalizedStrings.country} type="text" {...country}/>
                        </FormField>
                    </div>
                    <div className="form-row">
                        <FormField label={LocalizedStrings.promoCode} name="club" field={promo_code}>
                            <input ref="promo_code" placeholder={LocalizedStrings.promoCode} type="text" {...promo_code} disabled={id!=null}/>
                        </FormField>
                    </div>
                    <FormField label={LocalizedStrings.gdprConfirmation} name="gdpr_confirmation"
                               field={gdpr_confirmation} className="checkbox-field" dots={false} link={'/gdpr'}>
                        <input type="checkbox" {...gdpr_confirmation}/>
                    </FormField>


                    <FormField label={LocalizedStrings.agreeOnTerms} name="agree_on_regulations"
                               field={agree_on_regulations} className="checkbox-field"
                               link={`/stages/${stageId.value}/regulations`} dots={false}>
                        <input type="checkbox" {...agree_on_regulations}/>
                    </FormField>

                    <FormField label={LocalizedStrings.medicalConfirmation} name="medical_confirmation"
                               field={medical_confirmation} className="checkbox-field" dots={false}>
                        <input type="checkbox" {...medical_confirmation}/>
                    </FormField>

                    {selectedStage && selectedStage.insurance_enabled
                        ? <FormField label={this.getInsuranceLabel()} name="participate_in_insurance"
                                     field={participate_in_insurance} className="checkbox-field" link={'/insurance'}
                                     dots={false}>
                            <input type="checkbox" {...participate_in_insurance}/>
                        </FormField>
                        : null}

                    <FormField label={LocalizedStrings.marketingEmailConfirmation} name="marketing_email"
                               field={marketing_email} className="checkbox-field" dots={false}>
                        <input type="checkbox" {...marketing_email}/>
                    </FormField>



                    {displayPayed
                        ?
                        <FormField label={LocalizedStrings.payed} name="payed" field={payed} className="checkbox-field"
                                   dots={false}>
                            <input type="checkbox" {...payed}/>
                        </FormField>
                        : null}


                    <div className="actions-row">

                        {this.state.calculating? <div>{LocalizedStrings.calculating}</div>: <Button loading={submitting} submit={true} disabled={submitting} type="primary">
                          {LocalizedStrings.submit}
                      </Button>}

                    </div>

                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'participant-form',
    fields,
    validate,
    destroyOnUnmount: true
}, state => ({
    initialValues: state.participant.participant,
    stages: state.stage.availableStages.items
}))(ParticipantForm);



// WEBPACK FOOTER //
// ./src/js/components/participant/participant-form.js